<template>
    <div class="description">
      <div class="description__content">
        <div class="description__content--helper"></div>
        <h1 class="description__content--headline scrollFadeText" v-if="descriptionTitle"> {{ descriptionTitle  }}</h1>
        <p class="description__content--body scrollFadeBody">{{ descriptionBody }}</p>
      </div>
      <div class="description__image scrollFade" v-if="image.length">
        <div class="description__image__content" :style="{backgroundImage: 'url(' + image + ')'}"></div>
      </div>
    </div>
</template>

<script>
export default {
  name: "Description",
  props: {
    descriptionTitle: {
      default: '',
      required: false,
    },
    descriptionBody: {
      default: '',
      required: false
    },
    image: {
      default: '',
      required: false
    },
    imageWidth: {
      default: '100%',
      required: false
    }
  },
  data: () => ({
  }),
}
</script>

<style scoped>

</style>
